import { FC, useState } from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import ConnexionLayout from "../../components/ConnexionLayout";
import TextInput from "../../components/TextInput";
import Button from "../../components/Button";
import { formatErrors } from "../../utils/errors";

import { requestPasswordReset } from "../../services/api/auth";

import "./style.css";

const ForgotPassword: FC = () => {
    const location = useLocation();

    const [email, setEmail] = useState(location.state?.email || "");
    const [loading, setLoading] = useState(false);
    const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string }>(
        {}
    );
    const [error, setError] = useState<string | null>(null); // Erreur globale
    const [success, setSuccess] = useState<string | null>(null); // Message de succès

    const handleForgotPassword = async () => {
        setLoading(true);
        setError(null);
        setSuccess(null);
        setFieldErrors({});

        try {
            // Appel à l'API pour demander une réinitialisation
            await requestPasswordReset(email);

            // Afficher un message de succès
            setSuccess(
                "Si cette adresse e-mail est associée à un compte, un lien de réinitialisation a été envoyé."
            );
        } catch (err: any) {
            if (err.response && err.response.data) {
                if (err.response.data.errors) {
                    // Gestion des erreurs spécifiques aux champs
                    setFieldErrors(formatErrors(err.response.data.errors));
                } else {
                    // Gestion des erreurs globales
                    setError(
                        err.response.data.message || "Une erreur est survenue."
                    );
                }
            } else {
                setError("Impossible de se connecter au serveur.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConnexionLayout>
            <p className="connexion_card_title">Mot de passe oublié ?</p>
            <p className="connexion_card_subtitle forgotPassword_subtitle">
                Renseigne l’adresse e-mail avec laquelle tu t’es inscrit
            </p>
            <TextInput
                label="Adresse e-mail de récupération"
                placeholder="Ton adresse e-mail"
                value={email}
                setValue={setEmail}
                error={fieldErrors.email}
            />
            {error && <p className="error resetPassword_error">{error}</p>}
            {success && <p className="success_message">{success}</p>}
            <div className="forgot_password_button_container">
                {loading ? (
                    <CircularProgress
                        className="forgot_password_loader"
                        size={42}
                    />
                ) : (
                    <Button
                        label="Réinitialiser le mot de passe"
                        variant="secondary"
                        onClick={handleForgotPassword}
                    />
                )}
            </div>
        </ConnexionLayout>
    );
};

export default ForgotPassword;
